export const routePermissions: Record<string, number[]> = {
    '/Annotations': [-1, -2, 1, 2],
    '/Assignment': [-1, -2, 1, 2],
    '/Background': [-1, -2, 1, 2],
    '/BatchPrint': [-1, -2, 1, 2],
    '/BatchRedaction': [-1, -2, 1, 2],
    '/CodingForm': [-1, -2, 1, 2],
    '/Comments': [-1, -2, 1, 2],
    '/Dashboard': [-1, -2, 1, 2],
    '/DataAnalysisReport': [-1, -2, 1, 2],
    '/demo': [-1, -2, 1, 2, 3],
    '/DocExplorer': [-1, -2, 1, 2],
    '/DocumentViewer': [-1, -2, 1, 2, 3],
    '/Document': [-1, -2, 1, 2, 3],
    '/DomainDashboard': [-1, -2],
    '/Entity': [-1],
    '/ICE': [-1, -2, 1, 2],
    '/ingestion': [-1, -2, 1, 2],
    '/Instance': [-1],
    '/Keywords': [-1, -2, 1, 2],
    '/Production': [-1, -2, 1, 2],
    '/ProjectFields': [-1, -2, 1],
    '/Project': [-1, -2, 1],
    '/Proview': [-1, -2, 1, 2],
    '/Redaction': [-1, -2, 1, 2],
    '/Report': [-1, -2, 1, 2],
    '/Report/ExportData': [-1, -2, 1, 2, 3],
    '/ReviewerDashboard': [-1, -2, 1, 2, 3],
    '/Review': [-1, -2, 1, 2],
    '/SavedSearch': [-1, -2, 1, 2, 3],
    '/Search': [-1, -2, 1, 2, 3],
    '/SecurityGroups': [-1, -2, 1],
    '/Scheduler': [-1, -2, 1, 2],
    '/TagsAndFolders': [-1, -2, 1, 2],
    '/User': [-1, -2, 1, 2],
    '/WorkFlow': [-1, -2, 1, 2],
};
